import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import useGetSettingFinancialStatement from '../../../financial/common/useGetSettingFinancialStatement'
import { selectPeerOrganizationIds } from '../../store/slice'
import classes from './index.module.scss'
import {
  changeActiveTab,
  changeSelectedYear,
  selectActiveTab,
  selectYear,
  selectYearReports,
} from './store/slice'
import { getFinancialStatements } from './store/thunk'
import { BalanceSheet } from './tabs/BalanceSheet'
import { CashFlowsStatement } from './tabs/CashFlowsStatement'
import { IncomeStatement } from './tabs/IncomeStatement'

const TAB_LIST = [
  {
    label: 'companyAnalysis.peerAnalysis.BALANCE_SHEET',
    key: 1,
    children: <BalanceSheet />,
  },
  {
    label: 'companyAnalysis.peerAnalysis.INCOME_STATEMENT',
    key: 2,
    children: <IncomeStatement />,
  },
  {
    label: 'companyAnalysis.peerAnalysis.CASH_FLOW_STATEMENT',
    key: 3,
    children: <CashFlowsStatement />,
  },
]

export const Content = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const settingFS = useGetSettingFinancialStatement()

  const locale = useSelector((state) => state.i18n.locale)
  const activeTab = useSelector(selectActiveTab)
  const selectedYear = useSelector(selectYear)
  const yearReports = useSelector(selectYearReports)
  const peerOrganizationIds = useSelector(selectPeerOrganizationIds)

  const yearReportsBySetting = settingFS?.years
    ? settingFS?.years.map((item) => ({ label: item, value: item }))
    : yearReports

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    if (selectedYear) {
      dispatch(
        getFinancialStatements({
          realYear: selectedYear?.value,
          organizationId,
          peerOrganizationIds: peerOrganizationIds,
          ...settingFS,
        }),
      )
    }
  }, [selectedYear, peerOrganizationIds, locale])

  const onClickTab = (item) => {
    dispatch(changeActiveTab(item.key))
  }

  const onChangeSelectedYear = (e) => {
    dispatch(changeSelectedYear(e))
  }

  const renderContent = () => {
    if (activeTab) {
      return TAB_LIST.find((item) => item.key === activeTab)?.children
    }
  }

  return (
    <div className="flexColumn h100">
      <Element
        className={classes.tabContainer}
        style={{
          borderBottomWidth: 1,
          borderBottomStyle: 'solid',
          borderBottomColor: '#B5CEF8',
        }}
      >
        <div className={classes.tabs}>
          {TAB_LIST.map((tab) => (
            <Element
              key={tab.key}
              className={classes.tabItem}
              style={{
                color: tab.key === activeTab ? '#FFFFFF' : '#191D25',
                backgroundColor: tab.key === activeTab ? '#2C73E8' : '#F3F3F3',
              }}
              onClick={() => onClickTab(tab)}
            >
              <Translate value={tab.label} />
            </Element>
          ))}
        </div>

        <div className="fw600 dFlex alignItemsCenter">
          FY:
          <SelectCustom
            isI18n
            isBorderNone
            activeItem={selectedYear}
            className="fw600"
            data={yearReportsBySetting}
            chooseItem={onChangeSelectedYear}
            style={{ paddingLeft: 4 }}
          />
        </div>
      </Element>

      <div className="flex1">{renderContent()}</div>
    </div>
  )
}
